import axios from '@/axios'

export default {
  fetchAll(params, id){
    return axios.get(`/adjustment-details/all/${id}`, {params})
  },
  fetchLimit(params, id){
    return axios.get(`/adjustment-details/limit/${id}`, {params})
  },  
  fetchById(id){
    return axios.get(`/adjustment-details/${id}`)
  },    
  create(payload){
    return axios.post(`/adjustment-details`, payload)
  },
  update(id, payload){
    return axios.put(`/adjustment-details/${id}`, payload)
  },
  delete(id){
    return axios.delete(`/adjustment-details/${id}`)
  }, 
  deleteMultiple(payload){
    return axios.delete(`/adjustment-details`, payload)
  }
}